<template>
  <el-dialog
    :visible="isEditVoucherModalActive"
    :before-close="beforeClose"
    append-to-body
    width="600px"
    @open="onOpen"
  >
    <el-alert
      v-if="errorMessage"
      :title="errorMessage"
      type="error"
      show-icon
      style="position: fixed; top: 0; left: 0; z-index: 2004;"
      @close="$emit('clear-error-message')"
    />

    <div
      class="layout__position-center text__align-center"
    >
      <h3 class="text__colour-teal mb-20">
        {{ editableItem ? 'Edit voucher' : 'Add new voucher' }}
      </h3>

      <el-form
        v-model="isFormValid"
        :model="voucherData"
        :rules="rules"
        class="mb-20"
        ref="voucherForm"
      >
        <el-form-item
          class="mb-15"
          prop="Name"
        >
          <div>
            <el-row class="d-flex align-center">
              <el-col
                :span="8"
                class="text__colour-teal"
              >
                Code Name
              </el-col>

              <el-col
                :span="16"
              >
                <el-input
                  :disabled="isLoading"
                  placeholder="Code Name"
                  v-model="voucherData.Name"
                />
              </el-col>
            </el-row>
          </div>
        </el-form-item>
        <el-form-item
          class="mb-15"
          prop="CouponCode"
        >
          <div>
            <el-row class="d-flex align-center">
              <el-col
                :span="8"
                class="text__colour-teal"
              >
                Voucher Code
              </el-col>

              <el-col
                :span="16"
              >
                <el-input
                  :disabled="isLoading"
                  placeholder="Voucher Code"
                  v-model="voucherData.CouponCode"
                />
              </el-col>
            </el-row>
          </div>
        </el-form-item>
        <el-form-item
          class="mb-15"
          prop="DiscountValue"
        >
          <div>
            <el-row class="d-flex align-center">
              <el-col
                :span="8"
                class="text__colour-teal"
              >
                Value
              </el-col>

              <el-col
                :span="16"
              >
                <el-input
                  type="number"
                  class="hidden-number-actions"
                  :min="0"
                  :disabled="isLoading"
                  placeholder="Value"
                  v-model="voucherData.DiscountValue"
                />
              </el-col>
            </el-row>
          </div>
        </el-form-item>
        <el-form-item
          class="mb-15"
          prop="DiscountType"
        >
          <div>
            <el-row class="d-flex align-center">
              <el-col
                :span="8"
                class="text__colour-teal"
              >
                Voucher type(£/%)
              </el-col>

              <el-col
                :span="16"
              >
                <el-select
                  :disabled="isLoading"
                  placeholder="Voucher type(£/%)"
                  v-model="voucherData.DiscountType"
                >
                  <el-option
                    v-for="voucherType in voucherTypes"
                    :key="voucherType.value"
                    :value="voucherType.value"
                    :label="voucherType.label"
                  />
                </el-select>
              </el-col>
            </el-row>
          </div>
        </el-form-item>
        <el-form-item
          class="mb-15"
          prop="MinimumOrderValue"
        >
          <div>
            <el-row class="d-flex align-center">
              <el-col
                :span="8"
                class="text__colour-teal"
              >
                Minimum Order Value
              </el-col>

              <el-col
                :span="16"
              >
                <el-input
                  type="number"
                  class="hidden-number-actions"
                  :min="0"
                  :disabled="isLoading"
                  placeholder="Minimum Order Value"
                  v-model="voucherData.MinimumOrderValue"
                />
              </el-col>
            </el-row>
          </div>
        </el-form-item>
        <el-form-item
          class="mb-15"
          prop="MaximumDiscountAmount"
        >
          <div>
            <el-row class="d-flex align-center">
              <el-col
                :span="8"
                class="text__colour-teal"
              >
                Maximum Discount Amount
              </el-col>

              <el-col
                :span="16"
              >
                <el-input
                  type="number"
                  class="hidden-number-actions"
                  :min="0"
                  :disabled="isLoading"
                  placeholder="Maximum Discount Amount"
                  v-model="voucherData.MaximumDiscountAmount"
                />
              </el-col>
            </el-row>
          </div>
        </el-form-item>
        <el-form-item
          class="mb-15"
          prop="MinimumQuantity"
        >
          <div>
            <el-row class="d-flex align-center">
              <el-col
                :span="8"
                class="text__colour-teal"
              >
                Minimum Quantity
              </el-col>

              <el-col
                :span="16"
              >
                <el-input
                  type="number"
                  class="hidden-number-actions"
                  :min="0"
                  :disabled="isLoading"
                  placeholder="Minimum Quantity"
                  v-model="voucherData.MinimumQuantity"
                />
              </el-col>
            </el-row>
          </div>
        </el-form-item>
        <el-form-item
          class="mb-15"
          prop="MaximumUsageCountPerCustomer"
        >
          <div>
            <el-row class="d-flex align-center">
              <el-col
                :span="8"
                class="text__colour-teal"
              >
                Max Usage Per Customer
              </el-col>

              <el-col
                :span="16"
              >
                <el-input
                  type="number"
                  class="hidden-number-actions"
                  :min="0"
                  :disabled="isLoading"
                  placeholder="Max Usage Per Customer"
                  v-model="voucherData.MaximumUsageCountPerCustomer"
                />
              </el-col>
            </el-row>
          </div>
        </el-form-item>
        <el-form-item
          class="mb-15"
          prop="ApplicableOrderSource"
        >
          <div>
            <el-row class="d-flex align-center">
              <el-col
                :span="8"
                class="text__colour-teal"
              >
                Applicable Order Source
              </el-col>

              <el-col
                :span="16"
              >
                <el-select
                  :disabled="isLoading"
                  placeholder="Applicable Order Source"
                  v-model="voucherData.ApplicableOrderSource"
                >
                  <el-option
                    v-for="orderSourceType in orderSourceTypes"
                    :key="orderSourceType.value"
                    :value="orderSourceType.value"
                    :label="orderSourceType.label"
                  />
                </el-select>
              </el-col>
            </el-row>
          </div>
        </el-form-item>

        <el-form-item
          class="mb-15"
          prop="StartDate"
        >
          <div>
            <el-row class="d-flex align-center">
              <el-col
                :span="8"
                class="text__colour-teal"
              >
                Start day
              </el-col>

              <el-col
                :span="16"
              >
                <el-date-picker
                  v-model="voucherData.StartDate"
                  format="dd/MM/yyyy"
                  value-format="yyyy-MM-dd"
                  type="date"
                  :disabled="isLoading"
                  placeholder="Start date"
                />
              </el-col>
            </el-row>
          </div>
        </el-form-item>
        <el-form-item
          class="mb-15"
          prop="EndDate"
        >
          <div>
            <el-row class="d-flex align-center">
              <el-col
                :span="8"
                class="text__colour-teal"
              >
                End day
              </el-col>

              <el-col
                :span="16"
              >
                <el-date-picker
                  v-model="voucherData.EndDate"
                  format="dd/MM/yyyy"
                  value-format="yyyy-MM-dd"
                  type="date"
                  :disabled="isLoading"
                  placeholder="End date"
                />
              </el-col>
            </el-row>
          </div>
        </el-form-item>
      </el-form>

      <div
        class="d-flex layout__width-100 justify-center"
      >
        <el-button
          class="button__background-red-border button__base"
          :disabled="isLoading"
          @click.prevent="save"
        >
          Save
        </el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import Voucher from '../../../Models/Voucher';

export default {
  name: 'EditVoucherModal',

  props: {
    isEditVoucherModalActive: {
      type: Boolean,
      required: true,
    },

    editableItem: {
      type: Object | null,
      required: true,
    },

    isLoading: {
      type: Boolean,
      required: true,
    },

    errorMessage: {
      type: String,
      required: false,
      default: '',
    },
  },

  data() {
    return {
      voucherData: {},
      isFormValid: false,
      rules: {
        Name: [{
          required: true,
          message: 'Code Name is required',
        }],
        DiscountType: [{
          required: true,
          message: 'Voucher type is required',
        }],
        DiscountValue: [{
          required: true,
          message: 'Value is required',
        }],
        MinimumOrderValue: [{
          required: true,
          message: 'Minimum Order Value is required',
        }],
        MaximumDiscountAmount: [{
          required: true,
          message: 'Maximum Discount Amount is required',
        }],
        CouponCode: [{
          required: true,
          message: 'Voucher Code is required',
        }],
        MinimumQuantity: [{
          required: true,
          message: 'Minimum Quantity is required',
        }],
        MaximumUsageCountPerCustomer: [{
          required: true,
          message: 'Max Usage Per Customer is required',
        }],
        ApplicableOrderSource: [{
          required: true,
          message: 'Applicable Order Source is required',
        }],
        StartDate: [{
          required: true,
          message: 'Start Date is required',
        }],
        EndDate: [{
          required: true,
          message: 'End Date is required',
        }],
      },
      voucherTypes: [{
        value: 1,
        label: 'Amount',
      }, {
        value: 0,
        label: 'Percentage',
      }],
      orderSourceTypes: [{
        value: 1,
        label: 'Photofixr',
      }, {
        value: 6,
        label: 'PdfUpload',
      }, {
        value: 7,
        label: 'IMA',
      }],
    };
  },

  methods: {
    onOpen() {
      if (this.$refs.voucherForm) {
        this.$refs.voucherForm.resetFields();
      }

      this.voucherData = this.editableItem
        ? Voucher.make({ ...this.editableItem })
        : {};
    },

    beforeClose() {
      if (this.isLoading) {
        return;
      }

      this.voucherData = {};

      this.$emit('on-closed');
    },

    save() {
      this.$refs.voucherForm.validate(isValid => this.isFormValid = isValid);

      if (!this.isFormValid) {
        return;
      }

      this.$emit('save-voucher', Voucher.make({ ...this.voucherData }));
    },
  },
};
</script>
